/*
 * ZYLA - desktop hover-to-zoom for product gallery images.
 * Cursor-tracking magnify. Desktop only (hover + fine pointer, >=768px).
 * No dependencies. Event delegation so it survives Flickity's cloned
 * carousel cells and lazy-loaded images. Coexists with the existing
 * click-to-open lightbox (that overlay still works).
 */
(function () {
  'use strict';

  var hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function isDesktop() {
    return hoverMediaQuery.matches && window.innerWidth >= 768;
  }

  function init(gallery) {
    if (gallery.dataset.zylaZoom === 'on') return;
    gallery.dataset.zylaZoom = 'on';

    var active = null;

    function clear() {
      if (!active) return;
      active.classList.remove('zyla-zooming');
      active.style.removeProperty('--zoom-x');
      active.style.removeProperty('--zoom-y');
      active = null;
    }

    function zoomableMedia(item) {
      if (!item) return null;
      // Only still images - skip video / model / 3D slides.
      if (item.querySelector('video, iframe, model-viewer, product-model')) return null;
      var media = item.querySelector('.media-image');
      if (!media || !media.querySelector('img')) return null;
      return media;
    }

    gallery.addEventListener('pointermove', function (event) {
      if (!isDesktop()) { clear(); return; }

      var item = event.target.closest('.product-info-item');
      var media = item && gallery.contains(item) ? zoomableMedia(item) : null;

      if (!media) { clear(); return; }

      if (media !== active) {
        clear();
        active = media;
        active.classList.add('zyla-zooming');
      }

      var rect = active.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));

      active.style.setProperty('--zoom-x', x.toFixed(2) + '%');
      active.style.setProperty('--zoom-y', y.toFixed(2) + '%');
    });

    gallery.addEventListener('pointerleave', clear);
    gallery.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') clear();
    });
  }

  function boot() {
    var galleries = document.querySelectorAll('.product-images-wrapper');
    for (var i = 0; i < galleries.length; i++) init(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the product section reloads in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();
